import { ReactNode } from 'react';

import { BoxProps } from '../interface';
import { Box } from '../layout/Box';

export const PaperFormButtonArea = ({
  children,
  paddingTop,
}: Pick<BoxProps, 'paddingTop'> & {
  children: ReactNode;
}) =>
  children && (
    <Box
      margin={'0px auto'}
      paddingTop={paddingTop || '24px'}
      width={'100%'}
      flexDirection={'column'}
      alignItems={'center'}
      display={'flex'}
    >
      {children}
    </Box>
  );
